module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/merit-paper-13fbc1b4d427454eb9d5b953d3e3c11c.png";